import React from "react";
import {connect} from "react-redux";
import classNames from "classnames"
import {
  isSearchSidebarToggleVisibleByState,
} from "../../../helpers/sidebarsHelper";
import {ConfigurationsType} from "../../../types/configurations";
import {AllInterferometricStacksType, ProductImageStacType, SearchResultElementType} from "../../../types/product";
import FooterSearchResultDetailsSidebar from "./FooterSearchResultDetailsSidebar";
import BodySearchResultDetailsSidebar from "./BodySearchResultDetailsSidebar";
import HeaderSearchResultDetailsSidebar from "./HeaderSearchResultDetailsSidebar";
import {
  isInterferometricStackSearchResultElement,
  isProductImageSearchResultElement
} from "../../../helpers/searchResultsHelper";

interface PropsType {
  configurations: ConfigurationsType,
  isSearchSidebarToggleVisible: boolean,
  allInterferometricStacks: AllInterferometricStacksType,
  searchResultDetails: SearchResultElementType,
  selectedProducts: ProductImageStacType[],
}

const SearchResultDetailsSidebar = (props: PropsType) => {
  const {
    configurations,
    searchResultDetails,
    selectedProducts,
    isSearchSidebarToggleVisible,
    allInterferometricStacks,
  } = props;

  const isProductDetailsCase = isProductImageSearchResultElement(searchResultDetails);
  const isInterferometricStackCase = isInterferometricStackSearchResultElement(searchResultDetails);

  return (
    <div
      className={classNames("search-result-details", {
        "product-details": isProductDetailsCase,
        "interferometric-stack-details": isInterferometricStackCase,
      })}
    >
      <HeaderSearchResultDetailsSidebar
        searchResultDetails={searchResultDetails}
        isSearchSidebarToggleVisible={isSearchSidebarToggleVisible}
      />

      <BodySearchResultDetailsSidebar
        configurations={configurations}
        searchResultDetails={searchResultDetails}
      />

      <FooterSearchResultDetailsSidebar
        searchResultDetails={searchResultDetails}
        selectedProducts={selectedProducts}
        allInterferometricStacks={allInterferometricStacks}
        isProductDetailsCase={isProductDetailsCase}
        isInterferometricStackCase={isInterferometricStackCase}
      />
    </div>
  )
};

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  searchResultDetails: state.application.searchResultDetails,
  selectedProducts: state.product.selectedProducts,
  allInterferometricStacks: state.product.allInterferometricStacks,
  isSearchSidebarToggleVisible: isSearchSidebarToggleVisibleByState(state),
});

export default connect(mapStateToProps)(SearchResultDetailsSidebar)
